import { useState } from 'react';
import { Building2 } from 'lucide-react';
import { toast } from 'sonner';
import { Button, Input, PageHeader } from '../components/ui';
import { useAdminAuth } from '../hooks/useAdminAuth';
import { workspaceService } from '../services/workspaceService';

export default function WorkspaceApplicationPage() {
  const { organizerContext, refreshOrganizerContext } = useAdminAuth();
  const [name, setName] = useState('');
  const [saving, setSaving] = useState(false);
  const workspace = organizerContext?.workspaces[0];

  async function apply(event: React.FormEvent) {
    event.preventDefault();
    setSaving(true);
    try {
      await workspaceService.apply(name);
      await refreshOrganizerContext();
      toast.success('Workspace application submitted');
    } catch (error) {
      toast.error('Could not submit application', { description: error instanceof Error ? error.message : 'Unknown error' });
    } finally {
      setSaving(false);
    }
  }

  if (workspace) {
    const copy = {
      pending: 'Your organizer workspace is waiting for Rubikoo approval.',
      rejected: 'This workspace was not approved. You can contact Rubikoo or submit a new workspace application.',
      suspended: 'This workspace is suspended. Contact Rubikoo to restore access.',
      approved: 'Your workspace is approved. Choose it from Workspaces to manage events.',
    }[workspace.status];
    return <div className="p-8 max-w-2xl"><PageHeader title={workspace.name} description={copy} /><div className="rounded-2xl border border-gray-800 bg-gray-900/70 p-6 text-sm text-gray-300"><p className="font-medium capitalize text-white">Status: {workspace.status}</p><p className="mt-2 text-gray-400">Workspace access is separate from your account login. You can sign in while approval is pending, but event management opens only after approval.</p></div></div>;
  }

  return <div className="p-8 max-w-2xl"><PageHeader title="Create your organizer workspace" description="A workspace keeps your events, team, and data isolated from other organizers." /><form onSubmit={apply} className="rounded-2xl border border-gray-800 bg-gray-900/70 p-6 space-y-5"><div className="w-10 h-10 rounded-xl border border-sky-500/30 bg-sky-500/10 flex items-center justify-center text-sky-400"><Building2 size={20} /></div><Input label="Workspace name" value={name} onChange={(event) => setName(event.target.value)} placeholder="University of Alberta Engineering" required minLength={2} /><div className="flex justify-end"><Button type="submit" loading={saving}>Submit for approval</Button></div></form></div>;
}
